export const downloadFile = async (fileUrl, fileName, beforeCb = null, afterCb = null) => {
  try {
    if (beforeCb) {
      beforeCb()
    }

    const response = await fetch(fileUrl, { method: 'GET' })

    if (!response.ok) {
      console.error('Download failed. Error:', response)
    }

    const blob = await response.blob()
    const filename = fileName || 'download'
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Download failed. Error: ', error)
  } finally {
    if (afterCb) {
      afterCb()
    }
  }
}